import classNames from 'classnames';
import { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { _ } from '/@/locale';
import { useCatalogConfig } from '/@/store/catalog/apiProviders';
import { getSessionCountry } from '/@/store/session/selectors';
import styles from './styles.module.css';

const CatalogWarning = ({ brand, className, isDetailView }) => {
    const country = useSelector(getSessionCountry);
    const { data: catalogConfig } = useCatalogConfig({ brand: brand.id });
    const parseDate = catalogConfig && catalogConfig.lastUpdate && new Date(catalogConfig.lastUpdate);
    let d = catalogConfig ? parseDate : false;

    if (d) {
        const year = d.getFullYear();
        const month = d.getMonth();
        const day = d.getDate();
        d = `${day + 1}/${month + 1}/${year}`;
    }

    return (
        <div className={classNames(styles.titles, className && className)}>
            {country.code === 'BR' && brand.type === 'crop_protection' && (
                <Fragment>
                    <span className={styles.title}>
                        {_(
                            'ADVERTENCIA: Los agrotóxicos son productos peligrosos para la salud humana, animal y del medio ambiente. '
                        )}
                    </span>
                    <span>
                        {_(
                            'Antes de su manipulación, lea atentamente y siga las recomendaciones contenidas en el envase, la etiqueta y la prescripción. Utilice siempre equipo de protección durante la manipulación. Nunca permita la manipulación de este producto por parte de menores de edad. Desechar correctamente el embalaje y restos de este producto. No reutilice las botellas vacías de este producto. Informate sobre la importancia del manejo integrado de plagas. '
                        )}
                    </span>
                </Fragment>
            )}

            {d && !isDetailView && (
                <div>
                    <span>
                        {_('Última actualización de datos:')} {d}
                    </span>
                </div>
            )}
        </div>
    );
};

export default CatalogWarning;
